import { render, staticRenderFns } from "./Permits.vue?vue&type=template&id=359b7d8b&lang=pug&"
import script from "./Permits.vue?vue&type=script&lang=js&"
export * from "./Permits.vue?vue&type=script&lang=js&"
import style0 from "./Permits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports